import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BordMembersComponent } from './Components/bord-members/bord-members.component';
import { CompanyComponent } from './Components/company/company.component';
import { GroupsComponent } from './Components/groups/groups.component';
import { HomePageComponent } from './Components/home-page/home-page.component';
import { NewPollComponent } from './Components/new-poll/new-poll.component';
import { UserManagementComponent } from './Components/user-management/user-management.component';
import { VoteResultComponent } from './Components/vote-result/vote-result.component';
import { HeaderComponent } from './Components/header/header.component';
import { PollsComponent } from './Components/polls/polls.component';
import { AuthGuard } from 'src/app/auth.guard';
import { ExecuteComponent } from './Components/execute/execute.component';
import { SmsDetailsComponent } from './Components/sms-details/sms-details.component';

// import { RankedChoiceVoteingSmsComponent } from './Components/ranked-choice-voteing-sms/ranked-choice-voteing-sms.component';

const routes: Routes = [
  { path: 'home', component: HomePageComponent,
  children: [
    { path: 'board-member', component:BordMembersComponent, canActivate: [AuthGuard]},
    { path: 'groups', component:GroupsComponent, canActivate: [AuthGuard]},
    { path: 'new-poll', component:NewPollComponent, canActivate: [AuthGuard]},
    { path: 'manage', component:UserManagementComponent, canActivate: [AuthGuard]},
    { path: 'result', component:VoteResultComponent, canActivate: [AuthGuard]},
    { path: 'company', component:CompanyComponent, canActivate: [AuthGuard]},
    { path: 'execute', component:PollsComponent, canActivate: [AuthGuard]},
    { path: 'sms-detail/:smsId', component:SmsDetailsComponent, canActivate: [AuthGuard]},
    { path: 'execute-poll/:pollId', component:ExecuteComponent, canActivate: [AuthGuard]},
    // { path: 'sms-preview/:pollId', component:RankedChoiceVoteingSmsComponent, canActivate: [AuthGuard]},
    // { path: 'execute-poll/:pollId', component:ExecuteComponent, canActivate: [AuthGuard],
    // children: [
    //   { path: 'sms-detail/:smsId', component:SmsDetailsComponent, canActivate: [AuthGuard]}
    // ]},
    { path: '', redirectTo: 'board-member', pathMatch: 'full' },

    // { path: '', redirectTo: '/home/billing-overview', pathMatch: 'full' }

  ]},
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class HomeRoutingModule { }
